/* eslint-disable react/display-name */
import { useWindowSize } from "@react-hook/window-size/throttled";
import * as React from "react";
import ReactDOM from "react-dom";
import { useClickAway, useLatest } from "react-use";
const stopClick = (e) => {
    e.stopPropagation();
};
const PortalContainer = React.forwardRef(({ open, children, setPlacement, scrollPos, zIndex = 100, dataE2EId = "portal", }, ref) => {
    const setPlacementRef = useLatest(setPlacement);
    const [windowWidth, windowHeight] = useWindowSize();
    const root = React.useMemo(() => typeof document !== "undefined" ? document.createElement("div") : null, []);
    React.useEffect(() => {
        if (open && root && setPlacementRef.current) {
            window.document.body.appendChild(root);
            // use the attachedRef to place the portal just under the selected item text
            root.className = "not-moveable";
            root.style.position = "absolute";
            root.style.zIndex = String(zIndex);
            const styleRes = setPlacementRef.current(windowWidth, windowHeight, ref);
            for (const key of Object.keys(styleRes)) {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                root.style[key] = styleRes[key];
            }
        }
        return () => {
            try {
                if (root)
                    window.document.body.removeChild(root);
            }
            catch (err) {
                // was not appended yet
            }
        };
    }, [open, root, setPlacementRef, windowWidth, windowHeight]);
    React.useEffect(() => {
        if (!!scrollPos && open && root !== null && !!setPlacementRef.current) {
            const styleRes = setPlacementRef.current(windowWidth, windowHeight, ref);
            for (const key of Object.keys(styleRes)) {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                root.style[key] = styleRes[key];
            }
        }
    }, [scrollPos, open, setPlacementRef, windowWidth, windowHeight]);
    if (root)
        // Use a portal so we know the menu will always be on top
        return ReactDOM.createPortal(React.createElement("div", { ref: ref, onClick: stopClick, "data-e2e-id": dataE2EId }, children), root);
    return null;
});
export const PositionedPortal = React.forwardRef(({ children, onClickOutside, ...props }, ref) => {
    const newRef = React.useRef(null);
    const portalRef = ref || newRef;
    useClickAway(portalRef, (e) => onClickOutside?.(e));
    return (React.createElement(PortalContainer, { ...props, ref: portalRef }, children));
});
